/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/** Value formatters shared by entity configs (Travel and Real Estate). */

import { formatDate as formatAppDate } from "utils/DateTimeConversion";

export const formatDate = (value) => (value ? formatAppDate(value, "date") || "-" : "-");
export const formatDateTime = (value) => (value ? formatAppDate(value, "datetime") || "-" : "-");
export const formatBool = (value) => (value === true ? "Yes" : value === false ? "No" : "-");

/** early_bird / OFF_PLAN -> Early Bird / Off Plan */
export const formatEnumLabel = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return String(value)
    .replace(/[_-]+/g, " ")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

export const formatNumber = (value, digits = 0) => {
  if (value === null || value === undefined || value === "") return "-";
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return n.toLocaleString(undefined, { maximumFractionDigits: digits, minimumFractionDigits: 0 });
};

/** Money with the record's currency column (defaults to AED for RE records). */
export const formatMoney = (currencyField = "currency", fallbackCurrency = "") => (value, data) => {
  if (value == null || value === "") return "-";
  const currency = data?.[currencyField] || fallbackCurrency;
  const n = Number(value);
  const amount = Number.isFinite(n)
    ? n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    : value;
  return `${currency} ${amount}`.trim();
};

export const formatPct = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const n = Number(value);
  return Number.isFinite(n) ? `${Number(n.toFixed(2))}%` : `${value}%`;
};

/** Audit section fields: created/modified by (linked to the user) and dates. */
export const ENTITY_AUDIT_FIELDS = [
  { label: "Created By", field: "created_by_name", userIdField: "created_by" },
  { label: "Modified By", field: "updated_by_name", userIdField: "updated_by" },
  { label: "Created Date", field: "created_at", renderValue: formatDateTime },
  { label: "Modified Date", field: "updated_at", renderValue: formatDateTime },
];

/** Fields whose header title should show a date-only label (not raw ISO). */
export const DATE_PRIMARY_FIELDS = new Set([
  "departure_date",
  "return_date",
  "book_by_date",
  "created_at",
  "updated_at",
]);
